module Meevo.Components.Controls {
    declare let d3: any;

    class MeevoGoalsGaugeChartComponent implements angular.IComponentController {

        static $inject = ['$scope'];
        public goalDecimal: number;
        public actualDecimal: number;
        public chartClass: string;
        public parent: any;
        public goal: number;
        public actual: number;

        constructor(private $scope: ng.IScope) { }


        $onInit = () => {

            let chartClass: string = '.'.concat(this.chartClass);
            this.goalDecimal = this.parent.goal;
            this.actualDecimal = this.parent.actual;


        }

        drawChart = () => {

        }
    }

    
    angular.module('meevo.components.controls')
        .component('meevoGoalsGaugeChartComponent', <angular.IComponentOptions>{
            templateUrl: 'app/components/controls/charts/goalsGaugeChart/goalsGaugeChart.template.html',
            controller: MeevoGoalsGaugeChartComponent,
            controllerAs: 'vm',
            bindings: {
                chartClass: '@',
                goal: '<',
                actual: '<',
                mapFn: '='
            },
            require: {
                parent: '^^meevoGoalsTileComponent'
            }
        });
}